import React from "react";
import MetaTags from "./MetaTags";
import constants from "app/utils/constants";

const DefaultMetaTags = () => {
	return (
		<MetaTags
			title={constants.DEFAULT_PAGE_TITLE}
			description={constants.DEFAULT_PAGE_DESCRIPTION}
		/>
	);
};

export default DefaultMetaTags;
